module.exports = __webpack_public_path__ + "img/流体力学2_4.fbf073e7.jpg";